"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _postMessageHelper = _interopRequireDefault(require("@eig-builder/core-utils/helpers/post-message-helper"));

require("./style/localization.scss");

var _context = _interopRequireDefault(require("./context"));

var array = _propTypes["default"].array,
    string = _propTypes["default"].string,
    oneOfType = _propTypes["default"].oneOfType,
    object = _propTypes["default"].object;
/**
 * Text component  - this will render the text, using the provided "message"
 * the message should look simular to "appWrapper.components.drawerMainMenu.disclaimer"
 *
 * @class TextComponent
 * @extends {Component}
 * @param message - key of the translation key
 * @param values - array of values that can de used during string format
 */

var TextComponent =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(TextComponent, _Component);

  function TextComponent(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, TextComponent);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(TextComponent).call(this, props));

    _this.onClick = function (proxy, e) {
      proxy.preventDefault();
      proxy.stopPropagation();
      var _this$props = _this.props,
          message = _this$props.message,
          values = _this$props.values;
      var localize = _this.context.localize;
      var localized = localize(message, values);
      window.localizationPopup.open(_this.props.message, localized);

      _this.subscribeToTanslationChange();
    };

    _this.subscribeToTanslationChange = function () {
      _this.postMessageHandler = new _postMessageHelper["default"]();

      _this.postMessageHandler.bind('translation_message', function (data) {
        if (data.key === _this.props.message && _this.refs['text-span']) {
          if (_this.refs['text-span'].textContent) {
            _this.refs['text-span'].textContent = data.text;
          } else if (_this.refs['text-span'].innerHTML) {
            _this.refs['text-span'].innerHTML = data.text;
          }
        } // close the localisation popup


        window.localizationPopup.close();
      });
    };

    _this.unSubscribeToTanslationChange = function () {
      if (_this.postMessageHandler) {
        _this.postMessageHandler.clear();

        _this.postMessageHandler = null;
      }
    };

    _this.state = {
      dialog: null
    };
    return _this;
  }

  (0, _createClass2["default"])(TextComponent, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // unsubscript post message handler
      this.unSubscribeToTanslationChange();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          message = _this$props2.message,
          values = _this$props2.values,
          rest = (0, _objectWithoutProperties2["default"])(_this$props2, ["message", "values"]);
      var _this$context = this.context,
          localize = _this$context.localize,
          _localizeDebug = _this$context._localizeDebug;
      var localized = message;

      if (typeof localize === 'function') {
        localized = localize(message, values);

        if (localized !== null && (0, _typeof2["default"])(localized) === 'object') {
          var index = 0;

          if (localized.constructor === Array) {
            localized = localized.map(function (i) {
              return _react["default"].createElement("span", {
                key: index++
              }, i);
            });
          }
        }
      }

      if (_localizeDebug) {
        rest['data-original-message'] = message;
        return _react["default"].createElement("span", (0, _extends2["default"])({
          ref: "text-span",
          className: "localize-debug-mode-target"
        }, rest), _react["default"].createElement("div", {
          className: "localize-debug-mode-click-area",
          onClick: this.onClick
        }), localized);
      }

      return _react["default"].createElement("span", rest, localized);
    }
  }]);
  return TextComponent;
}(_react.Component);

TextComponent.propTypes = {
  message: string.isRequired,
  values: oneOfType([array, object])
};
TextComponent.defaultProps = {
  values: []
};
TextComponent.contextType = _context["default"];
var _default = TextComponent;
exports["default"] = _default;